<template>
  <div>
    <router-view></router-view>
<!--    <AlexChat class="fixed" style="right: 15px; bottom: 15px; z-index: 10" />-->
<!--    <vs-popup ref="custom_popup" :active="!isUserLoggedIn && activeMarketplace">-->

  </div>
</template>
<script>
import AlexChat from "./AlexChat";
import { sendMeOTPService, verifyOTPService } from "@/services/auth.service.js";
export default {
  components: {
    AlexChat,
  },
  data() {
    return {
      email: "",
      authPopup: false,
      otp: "",
      popup: false,
    };
  },
  computed: {
    otpSent() {
      return this.$store.state.auth.otpSent;
    },
    isUserLoggedIn() {
      return this.$store.state.auth.isUserLoggedIn;
    },
    activeMarketplace() {
      return this.$store.state.organization.orgData.activeMarketplace;
    },
    currentBoard() {
      return this.$store.state.boards.currentBoard;
    },
  },

  created() {
    let url = this.$route.path.split("/");
    const organizationSlug = url[1];
    const userId = url[3];
    if (organizationSlug) {
      this.$store
        .dispatch("organization/fetchOrganizationBySlug", organizationSlug)
        .then((res) => {
          console.log("res.data", res.data.data[0]._id);
          if (!res.data.data[0].activeMarketplace) this.$router.push("/");
          else {
            this.$store.dispatch("journey/fetchUserSegments", {
              orgId: res.data.data[0]._id,
            });
          }
        })
        .catch((err) => {
          throw err;
        });
      this.email = this.$route.query.email;
    }
  },
  mounted() {
    if (this.isUserLoggedIn) {
      let url = this.$route.path.split("/");
      const userId = url[3];
      this.popup = false;
      this.$vs.loading();
      this.$store
        .dispatch("users/fetchUser", this.$store.state.auth.user._id)
        .then((res) => {
          // console.log('userData', res.data);

          this.$store.commit(
            "editor/SET_PERSONAL_EVALUATION",
            res.data.personalEvaluation[0]
          );
          this.$store.commit(
            "editor/SET_CAREER_HISTORY",
            res.data.careerHistory
          );
          this.$store.commit(
            "editor/SET_EDUCATIONAL_QUALIFICATIONS",
            res.data.educationalQualifications
          );
          this.$store.commit("editor/SET_PROJECTS", res.data.projects);
          this.$store.commit(
            "editor/SET_EXTRA_CURRICULAR",
            res.data.extraCurricular[0]
          );
          this.$store.commit("editor/SET_PERSONALITY", res.data.personality[0]);
          this.$store
            .dispatch(
              "boards/fetchUserBoardData",
              this.$store.state.auth.user._id
            )
            .then((res) => {
              this.$vs.loading.close();
            })
            .catch((err) => {
              throw err;
            });
        })
        .catch((err) => {
          throw err;
        });
    } else {
      this.$refs.custom_popup.$el.childNodes[1].childNodes[0].style.display =
        "none";
      this.queryUrl = this.$route.query.url;
      if (this.queryUrl) {
        this.popup = false;
      } else {
        this.popup = true;
      }
    }
  },
  methods: {
    sendMeOTP() {
      const payload = {
        email: this.email,
        password: this.email,
        currentThis: this,
        userSource: "editor",
      };
      sendMeOTPService(payload);
    },
    verifyOTP() {
      let url = this.$route.path.split("/");
      const organizationSlug = url[1];
      const userId = url[3];
      const payload = {
        email: this.email,
        otp: this.otp,
        userId: userId,
        organizationSlug: organizationSlug,
        currentThis: this,
      };
      this.popup = false;
      verifyOTPService(payload);
    },
  },
};
</script>
